'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prepareUrl = exports.validateUrl = undefined;

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _isFunction = require('../validators/isFunction');

var _isFunction2 = _interopRequireDefault(_isFunction);

var _isString = require('../validators/isString');

var _isString2 = _interopRequireDefault(_isString);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * @description :: Validating the url
 * @param {String} _url :: the url to validate
 * @return {String} :: Validated url
 */
// Validators


var validateUrl = exports.validateUrl = function validateUrl(_url) {
  var url = (0, _isFunction2.default)(_url) ? _url() : _url;
  if (!(0, _isString2.default)(url)) console.warn('Expecting a string or a function that returns a string for the url but got ' + (typeof url === 'undefined' ? 'undefined' : (0, _typeof3.default)(url)));
  return '' + url;
};
/**
 * @description :: Combining and preparing urls for fetch execution
 * @param {Array} urls :: Array of urls
 * @return {String} :: Prepared url
 */


var prepareUrl = exports.prepareUrl = function prepareUrl() {
  for (var _len = arguments.length, urls = Array(_len), _key = 0; _key < _len; _key++) {
    urls[_key] = arguments[_key];
  }

  return urls.map(validateUrl).join('');
};